/**
 * Beta Banner Component
 *
 * Shows a dismissable disclaimer banner that Fairdrop is in beta
 * and has not been audited. Uses localStorage to remember dismissal.
 */

import { useState, useEffect } from 'react'

const STORAGE_KEY = 'fairdrop-beta-banner-dismissed'

export function BetaBanner() {
  const [dismissed, setDismissed] = useState(true) // Start hidden to prevent flash

  useEffect(() => {
    // Check localStorage on mount
    const wasDismissed = localStorage.getItem(STORAGE_KEY) === 'true'
    setDismissed(wasDismissed)
  }, [])

  const handleDismiss = () => {
    setDismissed(true)
    localStorage.setItem(STORAGE_KEY, 'true')
  }

  if (dismissed) {
    return null
  }

  return (
    <div className="beta-banner">
      <div className="beta-banner-content">
        <span className="beta-banner-badge">BETA</span>
        <span className="beta-banner-message">
          Fairdrop is in beta and has not been audited. Use at your own risk.
        </span>
      </div>
      <button
        className="beta-banner-close"
        onClick={handleDismiss}
        aria-label="Dismiss"
      >
        &times;
      </button>
    </div>
  )
}

export default BetaBanner
